import { Autocomplete, Button, Input, Toggle } from "src/components";
import crossIcon from "src/assets/cross.svg";
import { useToast } from "src/hooks/useToast";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/context/store";
import {
  addCounterStockist,
  getCompanyClusterStockist,
  getOrderChangeValidation,
  // addCounterStockistActiveInactive,
  // getEmailContactDetails,
  getOrderDetailsByOrderCode2,
  getProductDetails,
  replaceStockist,
  // sendMailToStockist,
} from "src/services/order-api";
import { useEventStatus } from "src/hooks/useEventStatus";
import { ordActions } from "src/context/order-slice";
import { generateUniqueID } from "src/constants/functions";
import { useCorpEventStatus } from "src/hooks/useCorpEventStatus";
import { getStockistSearchData, updateStockistStatus } from "src/services/counter-api"; //M10-9803

const EditStockistName = ({ onCloseModal }: { onCloseModal: () => void }) => {
  const [remarks, setRemarks] = useState<string>("");
  const [makeDefaultStockist, setMakeDefaultStockist] = useState<boolean>(false);
  const { toast } = useToast();
  const { orderDetailsFiltered, selectedCounterData } = useSelector((state: RootState) => state.ord);
  const [districtStockist, setDistrictStockist] = useState<any[]>([]);
  const [selectedStockist, setSelectedStockist] = useState<any>(null);
  const { withEventCheck } = useEventStatus();
  const { withCorpEventCheck } = useCorpEventStatus();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [clusterCode, setClusterCode] = useState<string>("");
  const dispatch = useDispatch();

  const orderDetails = orderDetailsFiltered?.[0];
  const [sendCancelEmail, setSendCancelEmail] = useState<boolean>(true);
  // Order Placed / Order Escalated → user chooses whether the old stockist gets the order cancel email
  const isPlacedOrEscalated = [0, 18].includes(Number(orderDetails?.orderStatusHdr?.order_status_id));

  // const sentMailToStockist = async (orderCode: string) => {
  //   const contactDetails = await getEmailContactDetails(
  //     selectedCounterData?.counter_location?.counter_hdr_id?.counter_code,
  //     selectedCounterData?.counter_location?.location_code,
  //     selectedCounterData?.company_code
  //   );
  //   if (contactDetails?.data?.data) {
  //     const payload = {
  //       orderId: orderCode,
  //       subscriberId: selectedStockist?.uid + "|" + selectedStockist?.stockistmail,
  //       orderProducts: orderDetailsFiltered?.[0]?.orderProducts,
  //       novuMetaData: {
  //         counter_actor_name: orderDetailsFiltered?.[0]?.counterInfo?.counter_name,
  //         company_name: orderDetailsFiltered?.[0]?.company_name,
  //         division_name: orderDetailsFiltered?.[0]?.division_name,
  //       },
  //       headerDetails: [
  //         {
  //           label: "Stockist Name",
  //           value: selectedStockist?.owner_name,
  //         },
  //         {
  //           label: "Order Number",
  //           value: orderCode,
  //         },
  //         {
  //           label: "Address",
  //           value: selectedCounterData?.counter_location?.address,
  //         },
  //         {
  //           label: "City Name",
  //           value: selectedCounterData?.counter_location?.city_code?.city_name,
  //         },
  //         {
  //           label: "Counter Name",
  //           value: orderDetailsFiltered?.[0]?.counterInfo?.counter_name,
  //         },
  //         {
  //           label: "MCI Number",
  //           value: selectedCounterData?.counter_location?.counter_hdr_id?.mci_register_number,
  //         },
  //         {
  //           label: "Clinic/Hospital Name",
  //           value: selectedCounterData?.counter_location?.clinic_name,
  //         },
  //       ],
  //       footerDetails: [
  //         {
  //           label: "MedVol Support No",
  //           value: "044-481-37024",
  //         },
  //         {
  //           label: "ASM Number",
  //           value:
  //             contactDetails?.data?.data?.[0]?.position_code?.emp_position_devrel?.[0]?.manager_positionhdr_id?.emp_master_hdr?.mobile_no ||
  //             "Not Available",
  //         },
  //         {
  //           label: "Doctor's Assistant Contact Number",
  //           value:
  //             contactDetails?.data?.data?.[0]?.counter_company_lnk_id?.counter_location?.counter_hdr_id?.delegate_hdr_id?.[0]?.mobile ||
  //             "Not Available",
  //         },
  //       ],
  //       type: "stockist_complete",
  //       actorType: "stockist",
  //       isOrder: true,
  //     };
  //     try {
  //       const response = await sendMailToStockist(payload);
  //       console.log("response", response);
  //     } catch (error: any) {
  //       console.error("Failed to send mail to stockist", error);
  //     }
  //   }
  // };
  //M10-9803-Unable to shift the order_ORDLUP02072515356 start
  const handleSaveChanges = async () => {
    window.sessionStorage.setItem("doctor_counter_id", selectedCounterData?.counter?.id);
    if (!selectedStockist) {
      toast({ description: "Please select stockist", variant: "destructive" });
      return;
    }
    // M10-13686
    // M10-13983
    const trimmedRemarks = remarks?.trim();
    if (!trimmedRemarks)
      return toast({ description: "Please enter remarks", variant: "destructive" });

    if (trimmedRemarks.length > 200)
      return toast({ description: "Max 200 characters allowed", variant: "destructive" });
    // M10-13983
    // M10-13686
    const payloadForValidation = {
      action: "ORDER_STOCKIST_CHANGE",
      order_number: orderDetails?.order_code,
      cmpstockistcode: selectedStockist?.company_stockist_code,
    };

    try {
      setIsLoading(true);

      const validationResponse = await getOrderChangeValidation(payloadForValidation);
      if (validationResponse?.data?.success !== "success") {
        toast({ description: validationResponse?.data?.message, variant: "destructive" });
        return;
      }

      const orderPayload = {
        data: {
          order_id: orderDetails?.order_id_int,
          old_stockist_name: orderDetails?.stockist_name,
          company_stockist_code: selectedStockist?.company_stockist_code,
          stockist_name: selectedStockist?.owner_name,
          reason: trimmedRemarks,
          order_code: orderDetails?.order_code,
          //M10-12940
          old_company_stockist_code: orderDetails?.company_stockist_code,
          company_code: orderDetails?.company_code,
          Cluster_Name: selectedStockist?.cluster_name,
          old_stockist_alias_code: orderDetails?.novu_metadata?.stockistData?.compStockistAliasCode,
          new_stockist_alias_code: selectedStockist?.compStockistAliasCode,
          //M10-12940
          reference_number: trimmedRemarks, //M10-12082
          ...(isPlacedOrEscalated && { send_cancel_email: sendCancelEmail }),
        },
        primary_key: orderDetails?.order_id_int,
        event_type: "ORDER_STOCKIST_REPLACE",
      };

      const stockistAddPayload = {
        data: {
          is_default: makeDefaultStockist,
          counter_hdr_id: selectedCounterData?.counter?.id,
          counter_company_id: orderDetailsFiltered?.[0]?.counter_company_location_id,
          remarks: trimmedRemarks,
          reference_number: trimmedRemarks,  //M10-12082
          location_id: selectedCounterData?.locations?.[0]?.id,
          cluster_code: selectedStockist?.cluster_code,
          company_code: orderDetailsFiltered?.[0]?.company_code,
          counter_code: orderDetailsFiltered?.[0]?.counter_code,
          stockist_cluster: selectedStockist?.stockistClusterLnk_id,
          u_code: generateUniqueID(),
        },
        primary_key: selectedCounterData?.counter?.id,
        event_type: "COUNTER_STOCKIST_ADD",
      };

      const clientParams = `counter_id=${selectedCounterData?.counter?.id}&cluster_code=${selectedStockist?.cluster_code}&counter_company_id=${selectedCounterData?.locations?.[0]?.companies?.[0]?.id}`;
      const stockistSearchRes = await getStockistSearchData(clientParams);

      const existingStockist = stockistSearchRes?.data?.find(
        (data: any) => data?.stockist_cluster?.id === selectedStockist?.stockistClusterLnk_id
      );

      // --- If stockist is already linked
      if (existingStockist) {
        if (makeDefaultStockist) {
          const updateBody = {
            counter_stockist_Lnk_Id: existingStockist?.counter_stockist_Lnk_Id,
            reference_number: trimmedRemarks,  //M10-12082
            counter_hdr_id: selectedCounterData?.counter?.id,
            location_id: selectedCounterData?.locations?.[0]?.id,
            company_code: orderDetailsFiltered?.[0]?.company_code,
            cluster_code: selectedStockist?.cluster_code,
            location_code: selectedCounterData?.locations?.[0]?.code,
            counter_code: orderDetailsFiltered?.[0]?.counter_code,
            counter_company_id: orderDetailsFiltered?.[0]?.counter_company_location_id,
            stockist_cluster: selectedStockist?.stockistClusterLnk_id,
            u_code: generateUniqueID(),
            is_default: true,
            active_status: "Y",
          };

          const defaultUpdateRes = await updateStockistStatus(updateBody, selectedCounterData?.counter?.id);

          // If another default exists, unset and retry
          if (defaultUpdateRes?.data?.data?.alredayexistdefault) {
            const unsetBody = {
              ...defaultUpdateRes?.data?.data,
              is_default: false,
              reference_number: trimmedRemarks,  //M10-12082
            };
            const unsetRes = await updateStockistStatus(unsetBody, selectedCounterData?.counter?.id);
            if (unsetRes?.status !== 200) {
              toast({ variant: "destructive", description: unsetRes?.data?.message ?? "Failed to unset the existing default stockist" });
              return;
            }

            const retryRes = await updateStockistStatus(updateBody, selectedCounterData?.counter?.id);
            if (retryRes?.status !== 200) {
              toast({ variant: "destructive", description: retryRes?.data?.message ?? "Failed to set the new default stockist" });
              return;
            }
          }

          toast({ description: "Default stockist updated successfully" });
        }

        // Proceed to replace stockist
        await proceedWithStockistReplace(orderPayload);

      } else {
        // Add stockist and replace
        const addRes = await addCounterStockist(stockistAddPayload);

        await proceedWithStockistReplace(orderPayload, addRes?.data?.eventStreamCreated?.streamId);
      }

    } catch (error: any) {
      console.error("Error in handleSaveChanges:", error);
      toast({
        description: error?.response?.data?.message || error?.message || "Unexpected error occurred",
        variant: "destructive",
      });
    } finally {
      setIsLoading(false);
      onCloseModal();
    }
  };

  // 🔁 Extracted reusable logic
  const proceedWithStockistReplace = async (orderPayload: any, eventStreamId?: string) => {
    const replaceRes = await withCorpEventCheck(
      () => replaceStockist(orderPayload, orderDetails?.company_code),
      eventStreamId
    );

    if (replaceRes?.status !== 200) throw new Error(replaceRes?.data?.message);

    // sentMailToStockist(orderDetails?.order_code);
    toast({ description: "Stockist updated successfully", variant: "default" });

    const updatedOrder = await withEventCheck(
      () => getOrderDetailsByOrderCode2(orderDetails?.order_code, orderDetails?.company_code),
      replaceRes?.data?.data?.eventStreamCreated?.streamId,
      orderDetails?.company_code  //M10-12758
    );

    dispatch(ordActions.setOrderDetailsFiltered([updatedOrder?.data?.data]));
  };
  //M10-9803-Unable to shift the order_ORDLUP02072515356 end

  const fetchProductsData = async () => {
    try {
      // const res = await getCounterOrderProductsByItemCode(
      //   orderDetailsFiltered?.[0]?.counter_company_location_id,
      //   orderDetailsFiltered?.[0]?.orderProducts?.[0]?.item_code
      // );
      const res2 = await getProductDetails(
        orderDetailsFiltered?.[0]?.orderProducts?.[0]?.item_code,
        orderDetailsFiltered?.[0]?.company_divisioncode
      );
      // setClusterCode(res?.data?.data?.[0]?.companyProducts?.item_division?.[0]?.cluster_code?.cluster_code);
      setClusterCode(res2?.data?.[0]?.item_division?.[0]?.cluster_code?.cluster_code)
    } catch (error: any) {
      toast({ description: error?.response?.data?.message, variant: "destructive" });
    }
  };

  const fetchDistrictStockistData = async () => {
    const response = await getCompanyClusterStockist(orderDetails?.company_code, clusterCode);
    // const response = await getCounterCompanyStockist(selectedCounterData?.counter_company_location_id, clusterCode);
    if (response?.status !== 200) throw new Error(response?.data?.error);
    setDistrictStockist(
      response?.data?.data
        ?.filter((stockist: any) => stockist?.company_stockist_code !== orderDetails?.company_stockist_code)
        .map((item: any) => ({
          ...item,
          cluster_name_company_stockist_code: ` ${item?.firm_name} - ${item?.compStockistAliasCode}`,
          unique_stockist_id: `${item?.cluster_code}-${item?.stockist_id}`,
        }))
    );
  };

  useEffect(() => {
    window.sessionStorage.removeItem("doctor_counter_id");
    fetchProductsData();
  }, []);

  useEffect(() => {
    if (clusterCode) {
      fetchDistrictStockistData();
    }
  }, [clusterCode]);

  return (
    <div className={`flex flex-col gap-y-2 mb-4 w-[340px] ${isPlacedOrEscalated ? "max-h-[360px]" : "max-h-[318px]"} mx-auto px-6 bg-white p-4 rounded-xl`}>
      <div className="flex justify-between items-center">
        <p className="text-normal py-1 font-semibold text-[#49484C]">Change Stockist</p>
        <Button className="bg-transparent -mr-3" onClick={onCloseModal}>
          <img src={crossIcon} alt="cross" className="w-5 h-5 font-bold invert cursor-pointer" />
        </Button>
      </div>
      <div className="">
        <p className="text-sm mb-2 mt-2 font-normal text-[#666666]">Stockist Code</p>
        {/* <p className="text-sm text-[#616161]">Invoice No</p> */}
        {/* <Input
          type="text"
          placeholder="Enter Stockist Code"
          value={stockistCode}
          onChange={(e) => setStockistCode(e.target.value)}
          className="w-full border py-4 border-[#D0D0D0] rounded-md p-2 h-8"
        /> */}
        <Autocomplete
          placeholder="Select Stockist"
          suggestionList={districtStockist}
          displayKey="cluster_name_company_stockist_code"
          uniqueKey="unique_stockist_id"
          additionalDisplayKey="city_name"
          QuaternaryDisplayKey="medvol_stockist_code"
          QuaternaryDisplayKeySearch={true}
          additionalDisplayKeySearch={true}
          onSelectionChange={(e: any) => setSelectedStockist(e)}
        />
      </div>
      <div>
        <p className="text-sm mb-2 mt-2 font-normal text-[#666666]">Remarks</p>
        {/* <p className="text-sm text-[#616161]">Invoice No</p> */}
        <Input
          type="text"
          placeholder="Enter Remarks"
          value={remarks}
          onChange={(e) => setRemarks(e.target.value)}
          className="w-full border py-4 border-[#D0D0D0] rounded-md p-2 h-8"
        />
      </div>
      <p className="text-sm flex items-center mb-2 mt-2 font-normal text-[#666666]">
        <span className="mr-2">Make Default Stockist</span>{" "}
        {/* <span
          className={`text-[#687182] cursor-pointer text-[10px] bg-[#E9EDF5] px-2 py-1 rounded-full ${makeDefaultStockist ? "bg-[#8051FF]" : ""}`}
          onClick={() => setMakeDefaultStockist(!makeDefaultStockist)}
        >
          {makeDefaultStockist ? <span className="text-[#8051FF]">On</span> : <span className="text-[#687182]">Off</span>}
        </span> */}
        <Toggle checked={makeDefaultStockist} onChange={() => setMakeDefaultStockist(!makeDefaultStockist)} />
      </p>
      {isPlacedOrEscalated && (
        <p className="text-sm flex items-center mb-2 font-normal text-[#666666]">
          <span className="mr-2">Send order cancel email to stockist</span>
          <Toggle checked={sendCancelEmail} onChange={setSendCancelEmail} />
        </p>
      )}

      <Button isLoading={isLoading} loaderSize="small" className="text-white bg-[#8051FF] mt-2" onClick={handleSaveChanges}>
        Save Changes
      </Button>
    </div>
  );
};

export default EditStockistName;
